import { FC } from "react";
import Link from "next/link";
import Section from "components/gonzo/parts/Section";
import AnchorTarget from "components/official/AnchorTarget";
import Headline from "components/gonzo/parts/Headline";
import Description from "components/gonzo/parts/Description";
import Content from "components/gonzo/parts/Content";
import BreakPc from "components/gonzo/parts/BreakPc";
import styled, { keyframes } from "styled-components";

const Exhibition30th: FC = () => {
  return (
    <Section>
      <AnchorTarget id="exhibition" />
      <Headline
        multiRow
        src={["/image/lp/gonzo/exhibition/exhibition_title_1.png", "/image/lp/gonzo/exhibition/exhibition_title_2.png"]}
        alt="オンライン展示会"
      />
      <Content>
        <Description>
          GONZO設立30周年を記念して、
          <BreakPc />
          様々なGONZO作品を振り返りながら楽しんで頂くために、イラスト・原画を展示しています。
          <br />
          <br />
          ＜開催期間＞
          <br />
          2023年1月19日（木）12:00 〜 1月31日（火）23:59まで
        </Description>
        <LinkArea>
          <Anchor href={`https://animuse.jp/pages/anime-museum-vol2`}>
            <span>オンライン展示会へ</span>
          </Anchor>
        </LinkArea>
      </Content>
    </Section>
  );
};
export default Exhibition30th;

const LinkArea = styled.div`
  display: flex;
  justify-content:center;
  text-align: center;
`;

const loginFlash = keyframes`
  0% {
    opacity: 0.5;
  }
  1% {
    opacity: 1;
  }
  2% {
    opacity: 0.7;
  }
  3% {
    opacity: 1;
  }
  4% {
    opacity: 0.6;
  }
  5% {
    opacity: 1;
  }
  6% {
    opacity: 1;
  }
  7% {
    opacity: 0.5;
  }
  8% {
    opacity: 1;
  }
  100% {
    opacity: 1;
  }
`;

const Anchor = styled.a`
  display: flex;
  background-size: cover;
  background-position: center;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  & > span {
    text-align: center;
    transform-origin: center;
  }

  &:hover {
    animation: ${loginFlash} 4.5s step-start infinite;

    & > span {
      text-shadow: -1px 0 0 lime, 1px 0 0 red;
    }
  }

  @media screen and (max-width: 960px) {
    width: 220px;
    height: 55px;
    background-image: url(/img/header_login_bg--sp.png);
    & > span {
      font-size: 15px;
    }
  }
  @media screen and (min-width: 961px) {
    width: 290px;
    height: 69px;
    background-image: url(/img/header_login_bg--pc.png);
    & > span {
      font-size: 20px;
      transition: 0.4s;
      transition-delay: 0.5s;
      text-shadow: -2px 0 0 rgba(0, 255, 0, 0), 2px 0 0 rgba(255, 0, 0, 0);
    }
  }
`;
